import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

function useIsAr() {
  const [isAr, setIsAr] = useState(false);
  const locale = useSelector(store => store.language.locale);

  useEffect(() => {
    setIsAr(locale === "ar");
  }, [locale]);

  return [isAr, locale];
}

export default useIsAr;
